import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { LoadingController, ModalController, NavParams, Platform } from '@ionic/angular';
// import { Keyboard } from 'ionic-native';
import { TeeBoxInfo } from 'src/data/club-course';
import { CompetitionInfo } from 'src/data/competition-data';
import { Country } from 'src/data/country-location';
import { GameRoundInfo } from 'src/data/game-round';
import { PlayerData, PlayerInfo, PlayerList } from 'src/data/mygolf.data';
import { TeeBox } from 'src/data/tee-box';
import { CommonProvider } from '../../commonServices/common';
import { Apiurl } from '../../commonServices/route';
import { Storage } from '@ionic/storage-angular'
import { PlayerService } from 'src/providers/player-service/player-service';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { MyGolfStorageService } from 'src/storage/mygolf-storage.service';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';


@Component({
    selector: 'app-player-list',
    templateUrl: './player-list.page.html',
    styleUrls: ['./player-list.page.scss'],
})
export class PlayerListPage implements OnInit {
    forVoucher: boolean = false;
    public competition: CompetitionInfo;
    public gameRound: GameRoundInfo;
    public headerName: string;
    public countryList: Array<Country>;
    public teeBox: Array<TeeBox>;
    public teeBoxes: Array<TeeBoxInfo>;
    public playerList: any;
    public searchPlayers: string;
    public players: Array<PlayerInfo> = [];
    public playersToExclude: Array<PlayerInfo> = [];
    public selectedPlayerId: number;
    searchAttempted: boolean = false;


    forResultOnly: boolean = false;
    bookingPlayers: Array<PlayerData> = [];
    constructor(public modalController: ModalController,
        private navParams: NavParams,
        private loadingCtl: LoadingController,
        private platform: Platform,
        private commonprovider: CommonProvider,
        private playerService: PlayerService,
        private storage: MyGolfStorageService,
        private keyboard: Keyboard
    ) {
        this.competition = this.navParams.get("competition");
        this.gameRound = this.navParams.get("gameRound");
        this.headerName = this.navParams.get("headerName");
        this.teeBoxes = navParams.get("teeBoxes");
        this.playerList = navParams.get("playerList");
        this.forVoucher = navParams.get("forVoucher");

        this.forResultOnly = navParams.get("forResultOnly")
        if (this.forResultOnly) this.bookingPlayers = this.playerList;


    }

    async ngOnInit() {
        // await this.storage.create()
        if (this.platform.is('ios') && this.platform.is('capacitor')) {
            this.keyboard.show();
        }
    }

    close() {
        if (this.platform.is('ios') && this.platform.is('cordova'))
        this.keyboard.hide();
        this.modalController.dismiss({
            selected: false
        })
    }

    ionViewDidLoad() {


        // this.getTeeBox();
    }

    getInnerHTML() {
        let description = "<p><span style='background-color:#00FFFF'>Tournaments, electronic scorecards, analysis and more&hellip; Look no further! myGolf2u is a single place where you can find and register for any </span>competitions in your region, your favourite clubs or in the entire country on your phone or in this site.</p>"
        return description;
    }

    countrySelected(country?: any) {
        if (country == null)
            this.modalController.dismiss();
        else this.modalController.dismiss(country);
    }

    onSearchInput(data) {

        this.searchPlayers = data.target.value;
        if (this.searchPlayers) {
            this.searchAttempted = true;
            this._searchPlayer();
        }
        else this.playerList = [];
        // this._clearAndRefresh(null);
    }


    async getCountry(cb?) {
        let loader = await this.loadingCtl.create({
            showBackdrop: false,
            message: 'Getting Country List...'
        });


        loader.present().then(() => {

            this.playerService.getCountryList()
                .subscribe((data: Array<Country>) => {
                    loader.dismiss().then(() => {

                        this.countryList = data;

                    })
                });
        })

        let token: any = null;
        await this.storage.getPreference('authToken').subscribe((value) => {
            token = value

        })

        // const headers = new HttpHeaders({
        //     "X-AUTH-TOKEN": token
        // })
        // this.commonprovider.GetMethod(Apiurl.RoutePath + Apiurl.getCountries,{ headers: headers }).then

        //     ((data: Array<Country>) => {

        //
        //         this.countryList = data;
        //

        //     });



        // setTimeout(()=>{

        //     cb();

        // }, 0)
    }

    getFlagUrl(flagUrl: string) {
        if (flagUrl == null) return null;
        else {
            let flagIcon = flagUrl.split("/");
            return "img/flag/" + flagIcon[2];
        }
    }

    async getTeeBox() {
        let loader = await this.loadingCtl.create({
            message: "Getting Teebox List...",
            showBackdrop: false
        });
        loader.present().then(() => {
            this.playerService.getTeeBox()
                .subscribe((data: Array<TeeBox>) => {
                    loader.dismiss().then(() => {

                        this.teeBox = data;

                    })
                }, (error) => {
                    loader.dismiss().then(() => {
                        loader = null;
                    });
                }, () => {
                    loader.dismiss().then(() => {
                        loader = null;
                    });
                });
        })
        // const headers = new HttpHeaders({
        //     "X-AUTH-TOKEN": "ewogICJ1c2VyIiA6IHsKICAgICJ1c2VySWQiIDogODA0MSwKICAgICJ1c2VybmFtZSIgOiAiZGF2aWRAbXlnb2xmMnUuY29tIiwKICAgICJhY3RpdmUiIDogdHJ1ZSwKICAgICJleHBpcmVzIiA6IDE2MjU1NTU1Njg4MzAsCiAgICAidXNlclR5cGUiIDogIlBsYXllciIsCiAgICAicGxheWVySWQiIDogODUxMSwKICAgICJjbHViSWQiIDogbnVsbCwKICAgICJvcmdhbml6ZXJJZCIgOiBudWxsLAogICAgImNhZGR5SWQiIDogbnVsbCwKICAgICJwYXJ0bmVySWQiIDogbnVsbCwKICAgICJhZG1pbiIgOiBmYWxzZSwKICAgICJlbWFpbCIgOiAiZGF2aWRAbXlnb2xmMnUuY29tIiwKICAgICJwaG9uZSIgOiBudWxsLAogICAgIm5hbWUiIDogIkRhdmlkICBCZWNraGFtICIsCiAgICAibmV3QXV0aCIgOiB0cnVlLAogICAgImFsZ29yaXRobSIgOiBudWxsLAogICAgImNvbWJpbmVVc2VybmFtZSIgOiBmYWxzZSwKICAgICJhdXRob3JpdGllcyIgOiBbIHsKICAgICAgIkBjbGFzcyIgOiAiY29tLmJyaXRlc29mdC5teWdvbGYuc2VjdXJpdHkuTXlnb2xmUm9sZSIsCiAgICAgICJhdXRob3JpdHkiIDogIlJPTEVfUExBWUVSIgogICAgfSBdCiAgfSwKICAiYXV0aGVudGljYXRlZCIgOiB0cnVlCn0=.fInveTyb7OsGIkRxyThJcKbsVbWbDkPBhByz0Jx7qnY="
        // })
        // this.commonprovider.GetMethod(Apiurl.RoutePath + Apiurl.getTeebox, { headers: headers }).then((data: Array<TeeBox>) => {

        //     this.teeBox = data;
        //
        // }

        // )

    }

    onSelectPlayer(p: any) {

        // if (this.platform.is('ios') && this.platform.is('capacitor'))
        // Keyboard.close();
        if (p) {

            if (this.forResultOnly) {

                this.modalController.dismiss({
                    selected: true,
                    player: p
                });
            } else {

                this.modalController.dismiss({
                    selected: true,
                    player: p
                });
            }

        }
        else {
            this.modalController.dismiss({
                selected: false
            });
        }



    }

    getTeeColor(color: string) {
        if (color === 'Blue') {
            return 'secondary'
        } else if (color === 'Red') {
            return 'danger'
        } else if (color === 'Black') {
            return 'dark'
        } else if (color === 'White') {
            return 'light'
        }
    }

    async _searchPlayer() {
        this.playerService.searchPlayers(this.searchPlayers, true, 1)
            .subscribe(async (playerList: PlayerList) => {

                if (playerList && playerList.players) {
                    this.playerList = playerList;
                    this.players = playerList.players.filter(p => {
                        let excluded = this.playersToExclude.find((pe => {
                            return pe.playerId === p.playerId;
                        }));
                        return !excluded;
                    });

                    // let filter = await this.modalController.create({
                    //     component: PlayerListPage,
                    //     componentProps: {
                    //         playerList: playerList
                    //     }
                    // });
                    // // filter.onDidDismiss((apply: boolean) => {
                    // filter.onDidDismiss().then((data: any) => {

                    //     if (data.selected) {
                    //         if(data.player)
                    //             this.selectedPlayerId = data.player.playerId


                    //     }
                    // })
                    // filter.present();

                }
            }, (error) => {

                MessageDisplayUtil.getErrorMessage(error, error)
            }, () => {

            });





    }


}
